import React, { useEffect, useState } from "react";
import { apiClient } from "../services/apiClient";
import DashboardLayout from "../components/DashboardLayout";
import AdminDashboardLayout from "../components/AdminDashboardLayout";
import ChangePasswordPage from "./ChangePasswordPage";

const normalizeRoleName = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  return raw;
};

const PasswordHome = () => {
  const [loading, setLoading] = useState(true);
  const [roleName, setRoleName] = useState("");

  useEffect(() => {
    let mounted = true;
    apiClient
      .get("/users/me")
      .then((res) => {
        if (!mounted) return;
        setRoleName(normalizeRoleName(res.data?.role_name));
        setLoading(false);
      })
      .catch(() => {
        if (!mounted) return;
        setRoleName("");
        setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (loading) return <div style={{ padding: 16 }}>Yükleniyor...</div>;

  const isPrivileged = ["admin", "company_manager", "hr", "unit_supervisor", "it"].includes(roleName);
  const Layout = isPrivileged ? AdminDashboardLayout : DashboardLayout;

  return (
    <Layout>
      <ChangePasswordPage />
    </Layout>
  );
};

export default PasswordHome;
